var map = {
	"./A栋B1层栅栏.mp4": 9439,
	"./A栋大堂南通道1.mp4": 5009,
	"./A栋负一楼西通道斜坡.mp4": 9570,
	"./A栋负二出入口.mp4": 6993,
	"./A栋负二楼电梯厅2.mp4": 1636,
	"./一期北围栏西球机.mp4": 4406,
	"./一期西通道球机.mp4": 1426,
	"./应急小门往会所.mp4": 7196,
	"./花园休息处平台.mp4": 7690,
	"./花园管理处拐弯楼梯口.mp4": 7271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7356;